export const card = {
  hidden: {
    y: 25,
    opacity: 0,
  },
  show: {
    y: 0,
    opacity: 1,
  }
};

export const complaintCards = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.09 },
  },
};

export const homePageItem = {
  hidden: {
    x: -20,
    opacity: 0,
  },
  show: {
    x: 0,
    opacity: 1,
  }
};

export const homePageItems = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.09 },
  },
};